import React from 'react';
import ReactDOM from 'react-dom';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { estados } from '../../util/estados';
import './UserForm.css';

const STATUS_OPTIONS = [
    { label: 'Ativo',                           value: 1 },
    { label: 'Suspenso',                        value: 0 },
    { label: 'Suspenso por Falta de Pagamento', value: 2 },
];

const AREA_OPTIONS = [
    'Novos Negócios', 'Comercial', 'Marketing',
    'Inteligência de Mercado', 'TI', 'Diretoria', 'Outros',
].map(a => ({ label: a, value: a }));

const SUSPENSION_HOURS_OPTIONS = [
    { label: '48 horas', value: '48' },
    { label: '72 horas', value: '72' },
];

class UserForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name:                            '',
            email:                           '',
            email_responsavel:               '',
            cpf:                             '',
            telefone:                        '',
            company:                         '',
            role_ids:                        [],
            cidade:                          '',
            estado:                          '',
            all_cities_grouped:              [],
            area:                            '',
            status:                          1,
            suspender_apos_horas_de_acesso:  '',
            suspension_date:                 '',
            notify_subscription:             true,
            photo:                           null,
            photo_preview:                   null,
            password:                        '',
            password_confirmation:           '',
            companies_options:               [],
            roles_options:                   [],
            errors:                          {},
            loading:                         false,
        };

        this.userId                = document.getElementById('js-user-form')?.dataset?.userId || null;
        this.isEdit                = !!this.userId;
        this.toastRef              = React.createRef();
        this.photoInputRef         = React.createRef();
        this.handleSubmit          = this.handleSubmit.bind(this);
        this.handleTelefoneChange  = this.handleTelefoneChange.bind(this);
        this.handleCompanyChange   = this.handleCompanyChange.bind(this);
        this.handleEstadoChange    = this.handleEstadoChange.bind(this);
        this.handlePhotoChange     = this.handlePhotoChange.bind(this);
    }

    componentDidMount() {
        const baseRequests = [
            axios.get('/companies/for-select'),
            axios.get('/roles/for-user-select'),
            axios.get('/cidades/for-select'),
        ];

        if (this.isEdit) {
            baseRequests.push(axios.get(`/user/${this.userId}/for-edit`));
        }

        Promise.all(baseRequests).then(([companiesRes, rolesRes, citiesRes, userRes]) => {
            const base = {
                companies_options:  companiesRes.data,
                roles_options:      rolesRes.data,
                all_cities_grouped: citiesRes.data,
            };

            if (userRes) {
                const u = userRes.data;
                Object.assign(base, {
                    name:                           u.name || '',
                    email:                          u.email || '',
                    email_responsavel:              u.email_responsavel || '',
                    cpf:                            u.cpf || '',
                    telefone:                       u.telefone || '',
                    company:                        u.company || '',
                    role_ids:                       u.role_ids || [],
                    cidade:                         u.cidade || '',
                    estado:                         u.estado || '',
                    area:                           u.area || '',
                    status:                         u.status !== undefined ? u.status : 1,
                    suspender_apos_horas_de_acesso: u.suspender_apos_horas_de_acesso || '',
                    suspension_date:                u.suspension_date || '',
                    notify_subscription:            !!u.notify_subscription,
                    photo_preview:                  u.photo_url || null,
                });
            }

            this.setState(base);
        });
    }

    handleEstadoChange(uf) {
        this.setState({ estado: uf, cidade: '' });
    }

    handleTelefoneChange(e) {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
        let masked = digits;

        if (digits.length > 10) {
            masked = digits.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
        } else if (digits.length > 6) {
            masked = digits.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
        } else if (digits.length > 2) {
            masked = digits.replace(/^(\d{2})(\d+)/, '($1) $2');
        } else if (digits.length > 0) {
            masked = digits.replace(/^(\d+)/, '($1');
        }

        this.setState({ telefone: masked });
    }

    handleCompanyChange(companyId) {
        const { companies_options, roles_options } = this.state;
        const company = companies_options.find(c => c.value === companyId);
        let defaultRoleNames = ['Cliente'];

        if (company && company.defaultRoleIds) {
            company.defaultRoleIds.forEach(rid => {
                const role = roles_options.find(r => r.id === rid);
                if (role && role.value !== 'Cliente') {
                    defaultRoleNames.push(role.value);
                }
            });
        }

        this.setState({ company: companyId, role_ids: defaultRoleNames });
    }

    handlePhotoChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        this.setState({
            photo:         file,
            photo_preview: URL.createObjectURL(file),
        });
        e.target.value = '';
    }

    handleSubmit(e) {
        e.preventDefault();
        const {
            name, email, email_responsavel, cpf, telefone,
            company, role_ids, cidade, estado,
            area, status, suspender_apos_horas_de_acesso, suspension_date,
            notify_subscription, photo, password, password_confirmation,
        } = this.state;

        const formData = new FormData();
        formData.append('name',               name);
        formData.append('email',              email);
        formData.append('email_responsavel',  email_responsavel);
        formData.append('cpf',                cpf || '');
        formData.append('telefone',           telefone);
        formData.append('company',            company);
        formData.append('estado',             estado);
        formData.append('area',               area || '');
        formData.append('status',             status);
        formData.append('suspension_date',    suspension_date || '');
        formData.append('notify_subscription', notify_subscription ? 'true' : 'false');
        formData.append('password',           password);
        formData.append('password_confirmation', password_confirmation);

        formData.append('suspender_apos_horas_de_acesso', suspender_apos_horas_de_acesso ?? '');

        formData.append('cidade', cidade);

        role_ids.forEach(r => formData.append('role_id[]', r));

        if (photo) formData.append('photo', photo);

        if (this.isEdit) {
            formData.append('_method', 'PUT');
        }

        this.setState({ loading: true, errors: {} });

        const url = this.isEdit ? `/user/${this.userId}` : '/user';

        axios.post(url, formData)
            .then(res => {
                const redirect = res.data.redirect;
                this.toastRef.current.show({
                    severity: 'success',
                    summary:  'Sucesso',
                    detail:   this.isEdit ? 'Usuário atualizado com sucesso.' : 'Usuário cadastrado com sucesso.',
                    life:      2500,
                });
                setTimeout(() => { window.location.href = redirect; }, 2500);
            })
            .catch(err => {
                if (err.response?.status === 422) {
                    this.setState({ errors: err.response.data.errors, loading: false });
                } else {
                    this.setState({ loading: false });
                }
            });
    }

    render() {
        const {
            name, email, email_responsavel, cpf, telefone,
            company, role_ids, cidade, estado, all_cities_grouped,
            area, status, suspender_apos_horas_de_acesso, suspension_date,
            notify_subscription, photo_preview,
            password, password_confirmation,
            companies_options, roles_options,
            errors, loading,
        } = this.state;

        const filtered_cities = estado
            ? (all_cities_grouped.find(g => g.label === estado)?.items || [])
            : [];

        return (
            <>
            <Toast ref={this.toastRef} position="top-right" />
            <form className="user-form" onSubmit={this.handleSubmit} encType="multipart/form-data">

                {/* Foto de perfil */}
                <div className="profile-avatar-section">
                    <div
                        className="profile-avatar"
                        onClick={() => this.photoInputRef.current.click()}
                        title="Clique para trocar a foto"
                    >
                        {photo_preview
                            ? <img src={photo_preview} alt="Foto de perfil" />
                            : <i className="fas fa-user profile-avatar-placeholder"></i>
                        }
                    </div>
                    {photo_preview
                        ? (
                            <button
                                type="button"
                                className="btn-photo btn-photo--remove"
                                onClick={() => this.setState({ photo: null, photo_preview: null })}
                            >
                                REMOVER
                            </button>
                        )
                        : (
                            <button
                                type="button"
                                className="btn-photo btn-photo--add"
                                onClick={() => this.photoInputRef.current.click()}
                            >
                                ADICIONAR
                            </button>
                        )
                    }
                    <input
                        type="file"
                        accept="image/*"
                        ref={this.photoInputRef}
                        style={{ display: 'none' }}
                        onChange={this.handlePhotoChange}
                    />
                    {errors.photo && <div className="uf-error">{errors.photo[0]}</div>}
                </div>

                {/* Informações básicas */}
                <h6 className="heading-small text-muted mb-4">Informações do Usuário</h6>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-md-6">
                            <label className={`uf-label${errors.name ? ' uf-label--error' : ''}`}>Nome*</label>
                            <InputText
                                className={`d-block w-100${errors.name ? ' p-invalid' : ''}`}
                                value={name}
                                onChange={e => this.setState({ name: e.target.value })}
                                placeholder="Nome completo"
                            />
                            {errors.name && <div className="uf-error">{errors.name[0]}</div>}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className={`uf-label${errors.cpf ? ' uf-label--error' : ''}`}>CPF</label>
                            <InputMask
                                className={`d-block w-100${errors.cpf ? ' p-invalid' : ''}`}
                                value={cpf}
                                onChange={e => this.setState({ cpf: e.value })}
                                mask="999.999.999-99"
                                placeholder="000.000.000-00"
                            />
                            {errors.cpf && <div className="uf-error">{errors.cpf[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-md-6">
                            <label className={`uf-label${errors.email ? ' uf-label--error' : ''}`}>Email*</label>
                            <InputText
                                className={`d-block w-100${errors.email ? ' p-invalid' : ''}`}
                                type="email"
                                value={email}
                                onChange={e => this.setState({ email: e.target.value })}
                                placeholder="email@exemplo.com"
                            />
                            {errors.email && <div className="uf-error">{errors.email[0]}</div>}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="uf-label">Email responsável</label>
                            <InputText
                                className="d-block w-100"
                                type="email"
                                value={email_responsavel}
                                onChange={e => this.setState({ email_responsavel: e.target.value })}
                                placeholder="responsavel@exemplo.com"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-sm-6 col-lg-4">
                            <label className="uf-label">Telefone</label>
                            <input
                                className="d-block w-100 p-inputtext"
                                value={telefone}
                                onChange={this.handleTelefoneChange}
                                placeholder="(00) 0000-0000 ou (00) 00000-0000"
                                maxLength={16}
                            />
                            {errors.telefone && <div className="uf-error">{errors.telefone[0]}</div>}
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                            <label className="uf-label">Estado</label>
                            <Dropdown
                                value={estado}
                                options={estados}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.handleEstadoChange(e.value)}
                                placeholder="Selecione o estado"
                                filter
                                filterPlaceholder="Buscar estado..."
                                showClear
                                className="w-100"
                            />
                        </div>
                        <div className="col-12 col-sm-12 col-lg-4">
                            <label className={`uf-label${errors.cidade ? ' uf-label--error' : ''}`}>Cidade*</label>
                            <Dropdown
                                value={cidade}
                                options={filtered_cities}
                                optionLabel="label"
                                optionValue="label"
                                onChange={e => this.setState({ cidade: e.value })}
                                placeholder={estado ? 'Selecione a cidade' : 'Selecione um estado primeiro'}
                                disabled={!estado}
                                filter
                                filterPlaceholder="Buscar cidade..."
                                className="w-100"
                            />
                            {errors.cidade && <div className="uf-error">{errors.cidade[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                {/* Empresa e Perfil */}
                <h6 className="heading-small text-muted mb-4 mt-4">Empresa e Perfil</h6>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-md-6">
                            <label className={`uf-label${errors.company ? ' uf-label--error' : ''}`}>Empresa</label>
                            <Dropdown
                                value={company}
                                options={companies_options}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.handleCompanyChange(e.value)}
                                placeholder="Selecione a empresa"
                                filter
                                filterPlaceholder="Buscar empresa..."
                                showClear
                                className="w-100"
                            />
                            {errors.company && <div className="uf-error">{errors.company[0]}</div>}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className={`uf-label${errors.role_id ? ' uf-label--error' : ''}`}>Perfil*</label>
                            <MultiSelect
                                value={role_ids}
                                options={roles_options}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ role_ids: e.value })}
                                placeholder="Selecione o(s) perfil(is)"
                                filter
                                filterPlaceholder="Buscar perfil..."
                                display="chip"
                                className="w-100"
                            />
                            {errors.role_id && <div className="uf-error">{errors.role_id[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                {/* Configurações adicionais */}
                <h6 className="heading-small text-muted mb-4 mt-4">Configurações</h6>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-md-6">
                            <label className="uf-label">Área</label>
                            <Dropdown
                                value={area}
                                options={AREA_OPTIONS}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ area: e.value })}
                                placeholder="Selecione a área"
                                showClear
                                className="w-100"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="uf-label">Status</label>
                            <Dropdown
                                value={status}
                                options={STATUS_OPTIONS}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ status: e.value })}
                                className="w-100"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-md-6">
                            <label className="uf-label">Suspender após</label>
                            <Dropdown
                                value={suspender_apos_horas_de_acesso}
                                options={SUSPENSION_HOURS_OPTIONS}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ suspender_apos_horas_de_acesso: e.value })}
                                placeholder="Selecione..."
                                showClear
                                className="w-100"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="uf-label">Data de suspensão</label>
                            <InputText
                                className="d-block w-100"
                                type="date"
                                value={suspension_date}
                                onChange={e => this.setState({ suspension_date: e.target.value })}
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group">
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
                            <InputSwitch
                                inputId="notify_subscription"
                                checked={notify_subscription}
                                onChange={e => this.setState({ notify_subscription: e.value })}
                            />
                            <label htmlFor="notify_subscription" className="uf-label mb-0" style={{ cursor: 'pointer' }}>
                                Notificar sobre assinatura
                            </label>
                        </div>
                    </div>
                </fieldset>

                {/* Senha */}
                <h6 className="heading-small text-muted mb-4 mt-4">Senha</h6>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-12 col-md-6">
                            <label className={`uf-label${errors.password ? ' uf-label--error' : ''}`}>Senha{!this.isEdit && '*'}</label>
                            <InputText
                                className={`d-block w-100${errors.password ? ' p-invalid' : ''}`}
                                type="password"
                                value={password}
                                onChange={e => this.setState({ password: e.target.value })}
                                placeholder={this.isEdit ? 'Deixe em branco para manter' : 'Mínimo 6 caracteres'}
                            />
                            {errors.password && <div className="uf-error">{errors.password[0]}</div>}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="uf-label">Confirmar senha{!this.isEdit && '*'}</label>
                            <InputText
                                className="d-block w-100"
                                type="password"
                                value={password_confirmation}
                                onChange={e => this.setState({ password_confirmation: e.target.value })}
                                placeholder="Repita a senha"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group">
                        <button
                            type="submit"
                            className="btn btn-primary uf-submit-btn"
                            disabled={loading}
                        >
                            {loading
                                ? <><i className="fa fa-spinner fa-spin"></i> Aguarde...</>
                                : this.isEdit ? 'Salvar alterações' : 'Criar Usuário'
                            }
                        </button>
                    </div>
                </fieldset>
            </form>
            </>
        );
    }
}

const mountPoint = document.getElementById('js-user-form');
if (mountPoint) {
    ReactDOM.render(<UserForm />, mountPoint);
}
